/**
 * Produces a color-mix tint against white for a given hex color.
 * `pct` is the percentage of the base color (0–100); higher = deeper color.
 *
 * Roles used in the design system:
 *   softTint    — 14% — subtle background wash (event rows, SourceEventList)
 *   surfaceTint — 30% — stronger header surface (SourceDefaults preview card)
 */
export const tint = (color: string, pct: number) =>
  `color-mix(in srgb, ${color} ${pct}%, #fff)`;

export const softTint = (color: string) => tint(color, 14);
export const surfaceTint = (color: string) => tint(color, 30);
